module.exports = __webpack_public_path__ + "static/media/schools_slide_1_mobile.6a9051cd.png";